import RequestAbstract from "../abstract";

export default class AccountingExpensesTransactions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/accounting-expenses-transactions";
    }

}
